export default {
    loading : false,
    types_operations:[],
    params: {
        date : null,
        voucherType : null,
        branchOffice : null,
        template : null,
        filter_lines: [],
        filter_sublines : [],
        filter_brands : [],
        filter_subbrands: [],
        product:[],
        contact : [],
        departament : [],
        city:[],
        seller:[],
        name_file:null,
        detailed_by_product:1,
        type_operations:[],
        f_exclude_lines:null,
        f_exclude_template:null,
        branchoffice_warehouse: null,
        include_prod_excludes:0,
        is_combo:0,
        date_generate: null,
},
    paramsquery:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
    },
    paramsVoucherType:{
        paginate : false,
        filter : null,
        branchoffice : null,
    },
    paramstemplates:{
        perPage: 1000,
        sortBy: 'id',
        sort: 'ASC',
        paginate : true,
        filter : null,
    },
    paramstemplates_exclude:{
        perPage: 1000,
        sortBy: 'id',
        sort: 'ASC',
        paginate : true,
        filter : null,
    },
    voucherTypes : [],
    branchOffices : [],
    templates :[],
    templates_exlude:[],
    lines :[],
    sublines :[],
    brands :[],
    subbrands :[],
    products:[],
    contacts:[],
    departaments:[],
    cities:[],
    sellers:[],
    branchofficeWarehouses:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    },
    report_data:[]
}



// WEBPACK FOOTER //
// ./src/modules/operations-report/state.js